import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {useImageListContext} from './context';
import styles from './back-button.module.css';

function nonNegative(n: number) {
  return Math.max(0, n);
}

export function ImageListBackButton() {
  const {currentSlidePage, setCurrentSlidePage} = useImageListContext();

  const onClick = () => {
    setCurrentSlidePage((previous) => nonNegative(previous - 1));
  };

  if (currentSlidePage === 1) return null;

  return (
    <button
      type='button'
      className={clsx(
        styles.backButton,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
      aria-label='前のページに戻る'
      onClick={onClick}
    >
      <svg
        role='img'
        aria-label='左矢印'
        width='18'
        height='20'
        viewBox='0 0 18 20'
        fill='none'
      >
        <g>
          <path
            d='M9.22656 2.73877L2.21801 9.78528L9.14812 16.7369'
            stroke='black'
            strokeWidth='2.00343'
            strokeMiterlimit='2'
          />
        </g>
        <g>
          <path
            d='M2.23828 9.73633H16.2382'
            stroke='black'
            strokeWidth='2.00161'
            strokeMiterlimit='1'
          />
        </g>
      </svg>
    </button>
  );
}
